import reducerRegistry from '../helpers/ReducerRegistry';
import Const from '../common/Const';
import currentState from './../helpers/CurrentState';

const { listComponent } = Const;
export const REDUCER_NAME = 'MAIN_LAYOUT';

export const SET_DRAG_POPUP = `${REDUCER_NAME}_SET_DRAG_POPUP`;
export const TOGGLE_ACTIVE_QUICK_COMPONENT = `${REDUCER_NAME}_TOGGLE_ACTIVE_QUICK_COMPONENT`;

export const setDragPopup = payload => ({
  type: SET_DRAG_POPUP,
  payload,
});

export const toggleActiveQuickComponent = componentName => ({
  type: TOGGLE_ACTIVE_QUICK_COMPONENT,
  payload: componentName,
});

const initialState = {
  dragPopup: {
    isShow: false,
    componentName: '',
    content: '',
    tooltip: '',
    title: '',
  },
  quickComponents: currentState.get(
    Const.KEY_COMMON_CURRENT_STATE,
    'quickComponents',
  ) || [
    {
      componentName: listComponent.Watchlist,
      content: `common.listComponent.${listComponent.Watchlist}`,
      icon: 'icon-calenda',
      isActive: true,
    },
    {
      componentName: listComponent.MarketInDepth,
      content: `common.listComponent.${listComponent.MarketInDepth}`,
      icon: 'icon-search1',
      isActive: true,
    },
    {
      componentName: listComponent.MarketCalendar,
      content: `common.listComponent.${listComponent.MarketCalendar}`,
      icon: 'icon-date',
      isActive: true,
    },
    {
      componentName: listComponent.MoneyFlow,
      content: `common.listComponent.${listComponent.MoneyFlow}`,
      icon: 'icon-money',
      isActive: true,
    },
    {
      componentName: listComponent.TimeAndSales,
      content: `common.listComponent.${listComponent.TimeAndSales}`,
      icon: 'icon-clock',
      isActive: true,
    },
    {
      componentName: listComponent.PriceDepth,
      content: `common.listComponent.${listComponent.PriceDepth}`,
      icon: 'icon-price-depth',
      isActive: false,
    },
    {
      componentName: listComponent.Charting,
      content: `common.listComponent.${listComponent.Charting}`,
      icon: 'icon-chart',
      isActive: false,
    },
    {
      componentName: listComponent.News,
      content: `common.listComponent.${listComponent.News}`,
      icon: 'icon-news-aggregator',
      isActive: false,
    },
    {
      componentName: listComponent.FASnapshot,
      content: `common.listComponent.${listComponent.FASnapshot}`,
      icon: 'icon-snapshot',
      isActive: false,
    },
    {
      componentName: listComponent.FinancialAnalysis,
      content: `common.listComponent.${listComponent.FinancialAnalysis}`,
      icon: 'icon-financial-analysis',
      isActive: false,
    },
  ],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DRAG_POPUP:
      return {
        ...state,
        dragPopup: {
          ...state.dragPopup,
          ...action.payload,
        },
      };
    case TOGGLE_ACTIVE_QUICK_COMPONENT:
      const quickComponents = state.quickComponents.map(component => {
        if (component.componentName === action.payload) {
          return {
            ...component,
            isActive: !component.isActive,
          };
        }

        return component;
      });

      currentState.add(
        Const.KEY_COMMON_CURRENT_STATE,
        'quickComponents',
        quickComponents,
      );

      return {
        ...state,
        quickComponents,
      };
    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
